// source: type/order_receive_method.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var type_custom_field_option_pb = require('../type/custom_field_option_pb.js');
goog.object.extend(proto, type_custom_field_option_pb);
goog.exportSymbol('proto.type.OrderReceiveMethod', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.CarColorType', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.DeliveryOption', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.DeliveryOption.OptionTypeCase', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.MethodTypeCase', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.NoneMethod', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.PickupOption', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.PickupOption.CarOption', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.PickupOption.LockerOption', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.PickupOption.OptionTypeCase', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.PickupOption.OtherShopOption', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethod.PickupOption.ShopOption', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethodOption', null, global);
goog.exportSymbol('proto.type.OrderReceiveMethodOption.ValueCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.OrderReceiveMethod.oneofGroups_);
};
goog.inherits(proto.type.OrderReceiveMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethod.displayName = 'proto.type.OrderReceiveMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethod.NoneMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.OrderReceiveMethod.NoneMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethod.NoneMethod.displayName = 'proto.type.OrderReceiveMethod.NoneMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethod.DeliveryOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.OrderReceiveMethod.DeliveryOption.oneofGroups_);
};
goog.inherits(proto.type.OrderReceiveMethod.DeliveryOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethod.DeliveryOption.displayName = 'proto.type.OrderReceiveMethod.DeliveryOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.displayName = 'proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.displayName = 'proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.displayName = 'proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethod.PickupOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.OrderReceiveMethod.PickupOption.oneofGroups_);
};
goog.inherits(proto.type.OrderReceiveMethod.PickupOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethod.PickupOption.displayName = 'proto.type.OrderReceiveMethod.PickupOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethod.PickupOption.CarOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.OrderReceiveMethod.PickupOption.CarOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethod.PickupOption.CarOption.displayName = 'proto.type.OrderReceiveMethod.PickupOption.CarOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethod.PickupOption.ShopOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.OrderReceiveMethod.PickupOption.ShopOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethod.PickupOption.ShopOption.displayName = 'proto.type.OrderReceiveMethod.PickupOption.ShopOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethod.PickupOption.LockerOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.OrderReceiveMethod.PickupOption.LockerOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethod.PickupOption.LockerOption.displayName = 'proto.type.OrderReceiveMethod.PickupOption.LockerOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethod.PickupOption.OtherShopOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.OrderReceiveMethod.PickupOption.OtherShopOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.displayName = 'proto.type.OrderReceiveMethod.PickupOption.OtherShopOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderReceiveMethodOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.OrderReceiveMethodOption.oneofGroups_);
};
goog.inherits(proto.type.OrderReceiveMethodOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderReceiveMethodOption.displayName = 'proto.type.OrderReceiveMethodOption';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.OrderReceiveMethod.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.type.OrderReceiveMethod.MethodTypeCase = {
  METHOD_TYPE_NOT_SET: 0,
  DELIVERY: 1,
  PICKUP: 2,
  NONE: 3
};

/**
 * @return {proto.type.OrderReceiveMethod.MethodTypeCase}
 */
proto.type.OrderReceiveMethod.prototype.getMethodTypeCase = function() {
  return /** @type {proto.type.OrderReceiveMethod.MethodTypeCase} */(jspb.Message.computeOneofCase(this, proto.type.OrderReceiveMethod.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    delivery: (f = msg.getDelivery()) && proto.type.OrderReceiveMethod.DeliveryOption.toObject(includeInstance, f),
    pickup: (f = msg.getPickup()) && proto.type.OrderReceiveMethod.PickupOption.toObject(includeInstance, f),
    none: (f = msg.getNone()) && proto.type.OrderReceiveMethod.NoneMethod.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of OrderReceiveMethod as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethod.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.delivery;

  /** @type {?|undefined} */
  this.pickup;

  /** @type {?|undefined} */
  this.none;

  /** @type {?|undefined} */
  this.text;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethod.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethod}
 */
proto.type.OrderReceiveMethod.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethod();
  obj.delivery && jspb.Message.setWrapperField(
      msg, 1, proto.type.OrderReceiveMethod.DeliveryOption.fromObject(obj.delivery));
  obj.pickup && jspb.Message.setWrapperField(
      msg, 2, proto.type.OrderReceiveMethod.PickupOption.fromObject(obj.pickup));
  obj.none && jspb.Message.setWrapperField(
      msg, 3, proto.type.OrderReceiveMethod.NoneMethod.fromObject(obj.none));
  obj.text != null && jspb.Message.setField(msg, 4, obj.text);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethod}
 */
proto.type.OrderReceiveMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethod;
  return proto.type.OrderReceiveMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethod}
 */
proto.type.OrderReceiveMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.OrderReceiveMethod.DeliveryOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.DeliveryOption.deserializeBinaryFromReader);
      msg.setDelivery(value);
      break;
    case 2:
      var value = new proto.type.OrderReceiveMethod.PickupOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.PickupOption.deserializeBinaryFromReader);
      msg.setPickup(value);
      break;
    case 3:
      var value = new proto.type.OrderReceiveMethod.NoneMethod;
      reader.readMessage(value,proto.type.OrderReceiveMethod.NoneMethod.deserializeBinaryFromReader);
      msg.setNone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDelivery();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.type.OrderReceiveMethod.DeliveryOption.serializeBinaryToWriter
    );
  }
  f = message.getPickup();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.type.OrderReceiveMethod.PickupOption.serializeBinaryToWriter
    );
  }
  f = message.getNone();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.type.OrderReceiveMethod.NoneMethod.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.type.OrderReceiveMethod.CarColorType = {
  WHITE: 0,
  BLACK: 1,
  SILVER: 2,
  RED: 3,
  BLUE: 4,
  GREEN: 5,
  OTHER_COLOR: 6,
  NONE_COLOR: 7
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethod.NoneMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethod.NoneMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethod.NoneMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.NoneMethod.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of NoneMethod as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethod.NoneMethod.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethod.NoneMethod.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethod.NoneMethod}
 */
proto.type.OrderReceiveMethod.NoneMethod.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethod.NoneMethod();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethod.NoneMethod}
 */
proto.type.OrderReceiveMethod.NoneMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethod.NoneMethod;
  return proto.type.OrderReceiveMethod.NoneMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethod.NoneMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethod.NoneMethod}
 */
proto.type.OrderReceiveMethod.NoneMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethod.NoneMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethod.NoneMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethod.NoneMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.NoneMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.OrderReceiveMethod.DeliveryOption.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.type.OrderReceiveMethod.DeliveryOption.OptionTypeCase = {
  OPTION_TYPE_NOT_SET: 0,
  HANDOVER: 1,
  CONTACTLESS: 2,
  UNATTENDED: 3
};

/**
 * @return {proto.type.OrderReceiveMethod.DeliveryOption.OptionTypeCase}
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.getOptionTypeCase = function() {
  return /** @type {proto.type.OrderReceiveMethod.DeliveryOption.OptionTypeCase} */(jspb.Message.computeOneofCase(this, proto.type.OrderReceiveMethod.DeliveryOption.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethod.DeliveryOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.DeliveryOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    handover: (f = msg.getHandover()) && proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.toObject(includeInstance, f),
    contactless: (f = msg.getContactless()) && proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.toObject(includeInstance, f),
    unattended: (f = msg.getUnattended()) && proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of DeliveryOption as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethod.DeliveryOption.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.handover;

  /** @type {?|undefined} */
  this.contactless;

  /** @type {?|undefined} */
  this.unattended;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethod.DeliveryOption();
  obj.handover && jspb.Message.setWrapperField(
      msg, 1, proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.fromObject(obj.handover));
  obj.contactless && jspb.Message.setWrapperField(
      msg, 2, proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.fromObject(obj.contactless));
  obj.unattended && jspb.Message.setWrapperField(
      msg, 3, proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.fromObject(obj.unattended));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethod.DeliveryOption;
  return proto.type.OrderReceiveMethod.DeliveryOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.deserializeBinaryFromReader);
      msg.setHandover(value);
      break;
    case 2:
      var value = new proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.deserializeBinaryFromReader);
      msg.setContactless(value);
      break;
    case 3:
      var value = new proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.deserializeBinaryFromReader);
      msg.setUnattended(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethod.DeliveryOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.DeliveryOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHandover();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.serializeBinaryToWriter
    );
  }
  f = message.getContactless();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.serializeBinaryToWriter
    );
  }
  f = message.getUnattended();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of HandoverOption as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption;
  return proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of ContactlessOption as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption;
  return proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    location: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of UnattendedOption as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.location;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption();
  obj.location != null && jspb.Message.setField(msg, 1, obj.location);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption;
  return proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string location = 1;
 * @return {string}
 */
proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption} returns this
 */
proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional HandoverOption handover = 1;
 * @return {?proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.getHandover = function() {
  return /** @type{?proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption, 1));
};


/**
 * @param {?proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption|undefined} value
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption} returns this
*/
proto.type.OrderReceiveMethod.DeliveryOption.prototype.setHandover = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.type.OrderReceiveMethod.DeliveryOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption} returns this
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.clearHandover = function() {
  return this.setHandover(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.hasHandover = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ContactlessOption contactless = 2;
 * @return {?proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.getContactless = function() {
  return /** @type{?proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption, 2));
};


/**
 * @param {?proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption|undefined} value
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption} returns this
*/
proto.type.OrderReceiveMethod.DeliveryOption.prototype.setContactless = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.type.OrderReceiveMethod.DeliveryOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption} returns this
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.clearContactless = function() {
  return this.setContactless(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.hasContactless = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UnattendedOption unattended = 3;
 * @return {?proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption}
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.getUnattended = function() {
  return /** @type{?proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption, 3));
};


/**
 * @param {?proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption|undefined} value
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption} returns this
*/
proto.type.OrderReceiveMethod.DeliveryOption.prototype.setUnattended = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.type.OrderReceiveMethod.DeliveryOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethod.DeliveryOption} returns this
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.clearUnattended = function() {
  return this.setUnattended(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethod.DeliveryOption.prototype.hasUnattended = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.OrderReceiveMethod.PickupOption.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.type.OrderReceiveMethod.PickupOption.OptionTypeCase = {
  OPTION_TYPE_NOT_SET: 0,
  CAR: 1,
  SHOP: 2,
  LOCKER: 3,
  OTHER_SHOP: 4
};

/**
 * @return {proto.type.OrderReceiveMethod.PickupOption.OptionTypeCase}
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.getOptionTypeCase = function() {
  return /** @type {proto.type.OrderReceiveMethod.PickupOption.OptionTypeCase} */(jspb.Message.computeOneofCase(this, proto.type.OrderReceiveMethod.PickupOption.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethod.PickupOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethod.PickupOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.PickupOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    car: (f = msg.getCar()) && proto.type.OrderReceiveMethod.PickupOption.CarOption.toObject(includeInstance, f),
    shop: (f = msg.getShop()) && proto.type.OrderReceiveMethod.PickupOption.ShopOption.toObject(includeInstance, f),
    locker: (f = msg.getLocker()) && proto.type.OrderReceiveMethod.PickupOption.LockerOption.toObject(includeInstance, f),
    otherShop: (f = msg.getOtherShop()) && proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of PickupOption as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethod.PickupOption.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.car;

  /** @type {?|undefined} */
  this.shop;

  /** @type {?|undefined} */
  this.locker;

  /** @type {?|undefined} */
  this.otherShop;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethod.PickupOption}
 */
proto.type.OrderReceiveMethod.PickupOption.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethod.PickupOption();
  obj.car && jspb.Message.setWrapperField(
      msg, 1, proto.type.OrderReceiveMethod.PickupOption.CarOption.fromObject(obj.car));
  obj.shop && jspb.Message.setWrapperField(
      msg, 2, proto.type.OrderReceiveMethod.PickupOption.ShopOption.fromObject(obj.shop));
  obj.locker && jspb.Message.setWrapperField(
      msg, 3, proto.type.OrderReceiveMethod.PickupOption.LockerOption.fromObject(obj.locker));
  obj.otherShop && jspb.Message.setWrapperField(
      msg, 4, proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.fromObject(obj.otherShop));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethod.PickupOption}
 */
proto.type.OrderReceiveMethod.PickupOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethod.PickupOption;
  return proto.type.OrderReceiveMethod.PickupOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethod.PickupOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethod.PickupOption}
 */
proto.type.OrderReceiveMethod.PickupOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.OrderReceiveMethod.PickupOption.CarOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.PickupOption.CarOption.deserializeBinaryFromReader);
      msg.setCar(value);
      break;
    case 2:
      var value = new proto.type.OrderReceiveMethod.PickupOption.ShopOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.PickupOption.ShopOption.deserializeBinaryFromReader);
      msg.setShop(value);
      break;
    case 3:
      var value = new proto.type.OrderReceiveMethod.PickupOption.LockerOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.PickupOption.LockerOption.deserializeBinaryFromReader);
      msg.setLocker(value);
      break;
    case 4:
      var value = new proto.type.OrderReceiveMethod.PickupOption.OtherShopOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.deserializeBinaryFromReader);
      msg.setOtherShop(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethod.PickupOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethod.PickupOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.PickupOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCar();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.type.OrderReceiveMethod.PickupOption.CarOption.serializeBinaryToWriter
    );
  }
  f = message.getShop();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.type.OrderReceiveMethod.PickupOption.ShopOption.serializeBinaryToWriter
    );
  }
  f = message.getLocker();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.type.OrderReceiveMethod.PickupOption.LockerOption.serializeBinaryToWriter
    );
  }
  f = message.getOtherShop();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethod.PickupOption.CarOption.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethod.PickupOption.CarOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethod.PickupOption.CarOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.PickupOption.CarOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    carColorType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of CarOption as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethod.PickupOption.CarOption.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.carColorType;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.CarOption.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.CarOption}
 */
proto.type.OrderReceiveMethod.PickupOption.CarOption.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethod.PickupOption.CarOption();
  obj.carColorType != null && jspb.Message.setField(msg, 1, obj.carColorType);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.CarOption}
 */
proto.type.OrderReceiveMethod.PickupOption.CarOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethod.PickupOption.CarOption;
  return proto.type.OrderReceiveMethod.PickupOption.CarOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.CarOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.CarOption}
 */
proto.type.OrderReceiveMethod.PickupOption.CarOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.type.OrderReceiveMethod.CarColorType} */ (reader.readEnum());
      msg.setCarColorType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethod.PickupOption.CarOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethod.PickupOption.CarOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.CarOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.PickupOption.CarOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCarColorType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional CarColorType car_color_type = 1;
 * @return {!proto.type.OrderReceiveMethod.CarColorType}
 */
proto.type.OrderReceiveMethod.PickupOption.CarOption.prototype.getCarColorType = function() {
  return /** @type {!proto.type.OrderReceiveMethod.CarColorType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.type.OrderReceiveMethod.CarColorType} value
 * @return {!proto.type.OrderReceiveMethod.PickupOption.CarOption} returns this
 */
proto.type.OrderReceiveMethod.PickupOption.CarOption.prototype.setCarColorType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethod.PickupOption.ShopOption.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethod.PickupOption.ShopOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethod.PickupOption.ShopOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.PickupOption.ShopOption.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of ShopOption as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethod.PickupOption.ShopOption.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.ShopOption.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.ShopOption}
 */
proto.type.OrderReceiveMethod.PickupOption.ShopOption.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethod.PickupOption.ShopOption();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.ShopOption}
 */
proto.type.OrderReceiveMethod.PickupOption.ShopOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethod.PickupOption.ShopOption;
  return proto.type.OrderReceiveMethod.PickupOption.ShopOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.ShopOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.ShopOption}
 */
proto.type.OrderReceiveMethod.PickupOption.ShopOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethod.PickupOption.ShopOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethod.PickupOption.ShopOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.ShopOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.PickupOption.ShopOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethod.PickupOption.LockerOption.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethod.PickupOption.LockerOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethod.PickupOption.LockerOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.PickupOption.LockerOption.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of LockerOption as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethod.PickupOption.LockerOption.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.LockerOption.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.LockerOption}
 */
proto.type.OrderReceiveMethod.PickupOption.LockerOption.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethod.PickupOption.LockerOption();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.LockerOption}
 */
proto.type.OrderReceiveMethod.PickupOption.LockerOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethod.PickupOption.LockerOption;
  return proto.type.OrderReceiveMethod.PickupOption.LockerOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.LockerOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.LockerOption}
 */
proto.type.OrderReceiveMethod.PickupOption.LockerOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethod.PickupOption.LockerOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethod.PickupOption.LockerOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.LockerOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.PickupOption.LockerOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethod.PickupOption.OtherShopOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of OtherShopOption as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.OtherShopOption}
 */
proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethod.PickupOption.OtherShopOption();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.OtherShopOption}
 */
proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethod.PickupOption.OtherShopOption;
  return proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.OtherShopOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethod.PickupOption.OtherShopOption}
 */
proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethod.PickupOption.OtherShopOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethod.PickupOption.OtherShopOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional CarOption car = 1;
 * @return {?proto.type.OrderReceiveMethod.PickupOption.CarOption}
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.getCar = function() {
  return /** @type{?proto.type.OrderReceiveMethod.PickupOption.CarOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.PickupOption.CarOption, 1));
};


/**
 * @param {?proto.type.OrderReceiveMethod.PickupOption.CarOption|undefined} value
 * @return {!proto.type.OrderReceiveMethod.PickupOption} returns this
*/
proto.type.OrderReceiveMethod.PickupOption.prototype.setCar = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.type.OrderReceiveMethod.PickupOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethod.PickupOption} returns this
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.clearCar = function() {
  return this.setCar(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.hasCar = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ShopOption shop = 2;
 * @return {?proto.type.OrderReceiveMethod.PickupOption.ShopOption}
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.getShop = function() {
  return /** @type{?proto.type.OrderReceiveMethod.PickupOption.ShopOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.PickupOption.ShopOption, 2));
};


/**
 * @param {?proto.type.OrderReceiveMethod.PickupOption.ShopOption|undefined} value
 * @return {!proto.type.OrderReceiveMethod.PickupOption} returns this
*/
proto.type.OrderReceiveMethod.PickupOption.prototype.setShop = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.type.OrderReceiveMethod.PickupOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethod.PickupOption} returns this
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.clearShop = function() {
  return this.setShop(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.hasShop = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LockerOption locker = 3;
 * @return {?proto.type.OrderReceiveMethod.PickupOption.LockerOption}
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.getLocker = function() {
  return /** @type{?proto.type.OrderReceiveMethod.PickupOption.LockerOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.PickupOption.LockerOption, 3));
};


/**
 * @param {?proto.type.OrderReceiveMethod.PickupOption.LockerOption|undefined} value
 * @return {!proto.type.OrderReceiveMethod.PickupOption} returns this
*/
proto.type.OrderReceiveMethod.PickupOption.prototype.setLocker = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.type.OrderReceiveMethod.PickupOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethod.PickupOption} returns this
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.clearLocker = function() {
  return this.setLocker(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.hasLocker = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional OtherShopOption other_shop = 4;
 * @return {?proto.type.OrderReceiveMethod.PickupOption.OtherShopOption}
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.getOtherShop = function() {
  return /** @type{?proto.type.OrderReceiveMethod.PickupOption.OtherShopOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.PickupOption.OtherShopOption, 4));
};


/**
 * @param {?proto.type.OrderReceiveMethod.PickupOption.OtherShopOption|undefined} value
 * @return {!proto.type.OrderReceiveMethod.PickupOption} returns this
*/
proto.type.OrderReceiveMethod.PickupOption.prototype.setOtherShop = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.type.OrderReceiveMethod.PickupOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethod.PickupOption} returns this
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.clearOtherShop = function() {
  return this.setOtherShop(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethod.PickupOption.prototype.hasOtherShop = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional DeliveryOption delivery = 1;
 * @return {?proto.type.OrderReceiveMethod.DeliveryOption}
 */
proto.type.OrderReceiveMethod.prototype.getDelivery = function() {
  return /** @type{?proto.type.OrderReceiveMethod.DeliveryOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.DeliveryOption, 1));
};


/**
 * @param {?proto.type.OrderReceiveMethod.DeliveryOption|undefined} value
 * @return {!proto.type.OrderReceiveMethod} returns this
*/
proto.type.OrderReceiveMethod.prototype.setDelivery = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.type.OrderReceiveMethod.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethod} returns this
 */
proto.type.OrderReceiveMethod.prototype.clearDelivery = function() {
  return this.setDelivery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethod.prototype.hasDelivery = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PickupOption pickup = 2;
 * @return {?proto.type.OrderReceiveMethod.PickupOption}
 */
proto.type.OrderReceiveMethod.prototype.getPickup = function() {
  return /** @type{?proto.type.OrderReceiveMethod.PickupOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.PickupOption, 2));
};


/**
 * @param {?proto.type.OrderReceiveMethod.PickupOption|undefined} value
 * @return {!proto.type.OrderReceiveMethod} returns this
*/
proto.type.OrderReceiveMethod.prototype.setPickup = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.type.OrderReceiveMethod.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethod} returns this
 */
proto.type.OrderReceiveMethod.prototype.clearPickup = function() {
  return this.setPickup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethod.prototype.hasPickup = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NoneMethod none = 3;
 * @return {?proto.type.OrderReceiveMethod.NoneMethod}
 */
proto.type.OrderReceiveMethod.prototype.getNone = function() {
  return /** @type{?proto.type.OrderReceiveMethod.NoneMethod} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.NoneMethod, 3));
};


/**
 * @param {?proto.type.OrderReceiveMethod.NoneMethod|undefined} value
 * @return {!proto.type.OrderReceiveMethod} returns this
*/
proto.type.OrderReceiveMethod.prototype.setNone = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.type.OrderReceiveMethod.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethod} returns this
 */
proto.type.OrderReceiveMethod.prototype.clearNone = function() {
  return this.setNone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethod.prototype.hasNone = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string text = 4;
 * @return {string}
 */
proto.type.OrderReceiveMethod.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.OrderReceiveMethod} returns this
 */
proto.type.OrderReceiveMethod.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.OrderReceiveMethodOption.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.type.OrderReceiveMethodOption.ValueCase = {
  VALUE_NOT_SET: 0,
  HANDOVER: 1,
  CONTACTLESS: 2,
  UNATTENDED: 3,
  CAR: 4,
  SHOP: 5
};

/**
 * @return {proto.type.OrderReceiveMethodOption.ValueCase}
 */
proto.type.OrderReceiveMethodOption.prototype.getValueCase = function() {
  return /** @type {proto.type.OrderReceiveMethodOption.ValueCase} */(jspb.Message.computeOneofCase(this, proto.type.OrderReceiveMethodOption.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderReceiveMethodOption.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderReceiveMethodOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderReceiveMethodOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethodOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    handover: (f = msg.getHandover()) && proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.toObject(includeInstance, f),
    contactless: (f = msg.getContactless()) && proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.toObject(includeInstance, f),
    unattended: (f = msg.getUnattended()) && proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.toObject(includeInstance, f),
    car: (f = msg.getCar()) && proto.type.OrderReceiveMethod.PickupOption.CarOption.toObject(includeInstance, f),
    shop: (f = msg.getShop()) && proto.type.OrderReceiveMethod.PickupOption.ShopOption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of OrderReceiveMethodOption as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderReceiveMethodOption.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.handover;

  /** @type {?|undefined} */
  this.contactless;

  /** @type {?|undefined} */
  this.unattended;

  /** @type {?|undefined} */
  this.car;

  /** @type {?|undefined} */
  this.shop;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderReceiveMethodOption.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderReceiveMethodOption}
 */
proto.type.OrderReceiveMethodOption.fromObject = function(obj) {
  var msg = new proto.type.OrderReceiveMethodOption();
  obj.handover && jspb.Message.setWrapperField(
      msg, 1, proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.fromObject(obj.handover));
  obj.contactless && jspb.Message.setWrapperField(
      msg, 2, proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.fromObject(obj.contactless));
  obj.unattended && jspb.Message.setWrapperField(
      msg, 3, proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.fromObject(obj.unattended));
  obj.car && jspb.Message.setWrapperField(
      msg, 4, proto.type.OrderReceiveMethod.PickupOption.CarOption.fromObject(obj.car));
  obj.shop && jspb.Message.setWrapperField(
      msg, 5, proto.type.OrderReceiveMethod.PickupOption.ShopOption.fromObject(obj.shop));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderReceiveMethodOption}
 */
proto.type.OrderReceiveMethodOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderReceiveMethodOption;
  return proto.type.OrderReceiveMethodOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderReceiveMethodOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderReceiveMethodOption}
 */
proto.type.OrderReceiveMethodOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.deserializeBinaryFromReader);
      msg.setHandover(value);
      break;
    case 2:
      var value = new proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.deserializeBinaryFromReader);
      msg.setContactless(value);
      break;
    case 3:
      var value = new proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.deserializeBinaryFromReader);
      msg.setUnattended(value);
      break;
    case 4:
      var value = new proto.type.OrderReceiveMethod.PickupOption.CarOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.PickupOption.CarOption.deserializeBinaryFromReader);
      msg.setCar(value);
      break;
    case 5:
      var value = new proto.type.OrderReceiveMethod.PickupOption.ShopOption;
      reader.readMessage(value,proto.type.OrderReceiveMethod.PickupOption.ShopOption.deserializeBinaryFromReader);
      msg.setShop(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderReceiveMethodOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderReceiveMethodOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderReceiveMethodOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderReceiveMethodOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHandover();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption.serializeBinaryToWriter
    );
  }
  f = message.getContactless();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption.serializeBinaryToWriter
    );
  }
  f = message.getUnattended();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption.serializeBinaryToWriter
    );
  }
  f = message.getCar();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.type.OrderReceiveMethod.PickupOption.CarOption.serializeBinaryToWriter
    );
  }
  f = message.getShop();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.type.OrderReceiveMethod.PickupOption.ShopOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional OrderReceiveMethod.DeliveryOption.HandoverOption handover = 1;
 * @return {?proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption}
 */
proto.type.OrderReceiveMethodOption.prototype.getHandover = function() {
  return /** @type{?proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption, 1));
};


/**
 * @param {?proto.type.OrderReceiveMethod.DeliveryOption.HandoverOption|undefined} value
 * @return {!proto.type.OrderReceiveMethodOption} returns this
*/
proto.type.OrderReceiveMethodOption.prototype.setHandover = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.type.OrderReceiveMethodOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethodOption} returns this
 */
proto.type.OrderReceiveMethodOption.prototype.clearHandover = function() {
  return this.setHandover(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethodOption.prototype.hasHandover = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OrderReceiveMethod.DeliveryOption.ContactlessOption contactless = 2;
 * @return {?proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption}
 */
proto.type.OrderReceiveMethodOption.prototype.getContactless = function() {
  return /** @type{?proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption, 2));
};


/**
 * @param {?proto.type.OrderReceiveMethod.DeliveryOption.ContactlessOption|undefined} value
 * @return {!proto.type.OrderReceiveMethodOption} returns this
*/
proto.type.OrderReceiveMethodOption.prototype.setContactless = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.type.OrderReceiveMethodOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethodOption} returns this
 */
proto.type.OrderReceiveMethodOption.prototype.clearContactless = function() {
  return this.setContactless(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethodOption.prototype.hasContactless = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional OrderReceiveMethod.DeliveryOption.UnattendedOption unattended = 3;
 * @return {?proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption}
 */
proto.type.OrderReceiveMethodOption.prototype.getUnattended = function() {
  return /** @type{?proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption, 3));
};


/**
 * @param {?proto.type.OrderReceiveMethod.DeliveryOption.UnattendedOption|undefined} value
 * @return {!proto.type.OrderReceiveMethodOption} returns this
*/
proto.type.OrderReceiveMethodOption.prototype.setUnattended = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.type.OrderReceiveMethodOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethodOption} returns this
 */
proto.type.OrderReceiveMethodOption.prototype.clearUnattended = function() {
  return this.setUnattended(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethodOption.prototype.hasUnattended = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional OrderReceiveMethod.PickupOption.CarOption car = 4;
 * @return {?proto.type.OrderReceiveMethod.PickupOption.CarOption}
 */
proto.type.OrderReceiveMethodOption.prototype.getCar = function() {
  return /** @type{?proto.type.OrderReceiveMethod.PickupOption.CarOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.PickupOption.CarOption, 4));
};


/**
 * @param {?proto.type.OrderReceiveMethod.PickupOption.CarOption|undefined} value
 * @return {!proto.type.OrderReceiveMethodOption} returns this
*/
proto.type.OrderReceiveMethodOption.prototype.setCar = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.type.OrderReceiveMethodOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethodOption} returns this
 */
proto.type.OrderReceiveMethodOption.prototype.clearCar = function() {
  return this.setCar(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethodOption.prototype.hasCar = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional OrderReceiveMethod.PickupOption.ShopOption shop = 5;
 * @return {?proto.type.OrderReceiveMethod.PickupOption.ShopOption}
 */
proto.type.OrderReceiveMethodOption.prototype.getShop = function() {
  return /** @type{?proto.type.OrderReceiveMethod.PickupOption.ShopOption} */ (
    jspb.Message.getWrapperField(this, proto.type.OrderReceiveMethod.PickupOption.ShopOption, 5));
};


/**
 * @param {?proto.type.OrderReceiveMethod.PickupOption.ShopOption|undefined} value
 * @return {!proto.type.OrderReceiveMethodOption} returns this
*/
proto.type.OrderReceiveMethodOption.prototype.setShop = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.type.OrderReceiveMethodOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.OrderReceiveMethodOption} returns this
 */
proto.type.OrderReceiveMethodOption.prototype.clearShop = function() {
  return this.setShop(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.OrderReceiveMethodOption.prototype.hasShop = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.type);
